import { render, staticRenderFns } from "./Shortcuts.vue?vue&type=template&id=576b2fc3&scoped=true"
import script from "./Shortcuts.vue?vue&type=script&lang=js"
export * from "./Shortcuts.vue?vue&type=script&lang=js"
import style0 from "./Shortcuts.vue?vue&type=style&index=0&id=576b2fc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576b2fc3",
  null
  
)

export default component.exports